import { Injectable, Optional } from '@angular/core';
import {
    DwAction, DwActionHandler, DwActionResult, DwActionState, DwActionType, DwEventService, DwMenuService,
    DwMetaDataFormStateService, DwModalConfig, DwModalService, DwModalSize, DwRoutingService
} from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppPermissions } from '../../../meta-data/app-permissions.enum';
import { SchoolSelectionModalComponent } from '../components/school-selection-modal/school-selection-modal.component';

@DwAction({
    keyName: 'school-select-modal-action',
    display: 'School Select Modal',
    actionType: DwActionType.menuAction,
    isGlobal: true,
    defaultSecurityConfig: {
        requireAuthentication: true,
        useEmulatedPermissions: false,
        permissionMeaning: AppPermissions.lMSSetupAdmin,
    }
})
@Injectable()
export class SchoolSelectionModalActionService implements DwActionHandler {
    constructor(
        private dwModalService: DwModalService,
        private dwMenuService: DwMenuService,
        private dwRoutingService: DwRoutingService,
        @Optional() private dwFormStateService: DwMetaDataFormStateService,
        private dwEventService: DwEventService
    ) {
    }

    handleAction(actionState: DwActionState<any>): Observable<DwActionResult> {
        return this.showModal(actionState);
    }

    private showModal(actionState: DwActionState<any>): Observable<DwActionResult> {
        let modalConfig = new DwModalConfig();

        modalConfig.allowFullScreen = false;
        modalConfig.modalSize = DwModalSize.custom;
        modalConfig.customModalWidth = 'min(440px, calc(100vw - 2rem))';
        modalConfig.customModalHeight = 'auto';
        modalConfig.modalClass = 'school-switch-dialog';
        modalConfig.hideFooter = true;

        modalConfig.component = SchoolSelectionModalComponent;

        modalConfig.title = 'Change School';

        return this.dwModalService.showModal<any,any>(modalConfig)
            .pipe(map(modalResult => {
                const result = new DwActionResult();
                
                if (modalResult.cancelled) {
                    result.cancelled = true;

                    return result;
                }

                result.success = true;
                result.message = 'School changed successfully';
                
                return result;
            }));
    }
}